export {useInteractOutside, type InteractOutsideProps} from '../src/interactions/useInteractOutside';
